/**
 * Dispara download de um Blob no navegador.
 * @param {Blob} blob
 * @param {string} filename
 */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/**
 * Dispara download a partir de resposta arraybuffer (ex.: Excel).
 * @param {ArrayBuffer} arrayBuffer
 * @param {string} filename
 * @param {string} mimeType - default planilha Excel
 */
export function downloadFromArrayBuffer(arrayBuffer, filename, mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
  const blob = new Blob([arrayBuffer], { type: mimeType });
  downloadBlob(blob, filename);
}
